const g2 = require('../../g2');
const ComponentBase = require('../../base/ComponentBase');
const CommonUtil = require('../../utils/CommonUtil');
const TooltipWare = require('./TooltipWare');
const NoneSpatialTipWare = require('./NoneSpatialTipWare');
/**
 * @constructor
 * @classdesc 地图弹出框管理
 * @augments G.base.ComponentBase
 * @alias G.common.PopupManager
 * @param {Object} options 构造参数；
 * @param {G.Map} options.map 地图对象
 * @param {Number} [options.autoPanMargin] 自动调整视野的边距，默认为10
 * @param {Number} [options.autoPanTimeout] 更新位置的延时
 * @param {Number} [options.zIndex] 层级
 * @param {Number} [options.offset] 
 * @param {String} [options.noneSpatialContainerId] 默认的无坐标弹框的容器
 * @param {String} [options.noneSpatialContainerClass]  默认的无坐标弹框的容器样式名
 * @example
 * //使用示例代码
 * //todo
 */
let component = ComponentBase.extend({
    options: {
        // 自动调整视野的方式
        autoPanStretegy: 0,
        autoPanMargin: 10,
        // 更新位置的延时
        autoPanTimeout: 300,
        // 层级
        zIndex: 10,
        //
        offset: [0, 0],
        // 位置计算
        caculator: {  
            // 获取计算位置的子元素
            contentEl: function(el) {
                return el.children[0];
            },
            // 计算css 位置
            offsetFn: function(el) {
                const jEl = jQuery(el);
                return jEl.offset();
            },
            // 计算尺寸
            sizeFn: function(el) {
                const jEl = jQuery(el);
                return [jEl.outerWidth(), jEl.outerHeight()];
            },
        },
        // 默认的无坐标弹框的容器
        noneSpatialContainerId: 'ns-popup-container',
        noneSpatialContainerClass: 'ns-popup-container',
    },
    initialize(options) {
        ComponentBase.prototype.initialize.call(this, options);
        //
        this.timer = null;
    },
    /**
     * 销毁
     * @inheritdoc
     */
    destroy() {
        //
        ComponentBase.prototype.destroy.call(this);
    },
    /**
     * @inheritdoc
     */
    load() {
        ComponentBase.prototype.load.call(this);
        //
        this.tooltipWare = new TooltipWare({
            map: this.map,
            caculator: this.options.caculator,
        });
        //
        this.noneSpatialTipWare = new NoneSpatialTipWare({
            containerId: this.options.noneSpatialContainerId,
            containerClassName: this.options.noneSpatialContainerClass,
            map: this.map,
        });
    },
    /**
     * @inheritdoc
     */
    unload() {
        this.clear();
        this.tooltipWare = null;
        //
        ComponentBase.prototype.unload.call(this);
    },
    /**
     * 添加简单弹框
     * @method
     * @memberof G.common.PopupManager.prototype
     * @param {Object} opts 
     * @param {String} [opts.id]  唯一标识
     * @param {Array} opts.anchor  [x,y]，弹出框地图位置
     * @param {Array} [opts.offset]  [offsetX,offsetY]，水平垂直偏移像素值
     * @param {String} [opts.className]  样式名
     * @param {String} [opts.layerId]  图层id
     * @param {Boolean} [opts.autoPan]  自动调整视野，默认为true，不弹则为false
     * @param {Number} [opts.autoPanMargin] 自动调整视野的边距，默认为10
     * @param {Boolean} [opts.autoPanTimeout]  自动调整视野的延时
     * @param {Number} [opts.zIndex] 层级
     * @param {Number} [options.offset] 
     */
    addSimple(opts) {
        opts.id = opts.id || CommonUtil.newUUID32();
        opts.type = 'simple';
        if (opts.zIndex === undefined) {
            opts.zIndex = this.options.zIndex;
        }
        if (opts.offset === undefined) {
            opts.offset = this.options.offset;
        }
        if (opts.autoPanMargin === undefined) {
            opts.autoPanMargin = this.options.autoPanMargin;
        }
        if (opts.autoPanStretegy === undefined) {
            opts.autoPanStretegy = this.options.autoPanStretegy;
        }
        let promise = null;
        if (opts.anchor) {
            promise = this.tooltipWare.addPopup(opts);
            this._triggerUpdateTimer(opts);
        } else {
            promise = this.noneSpatialTipWare.addPopup(opts);
        }
        //
        this.fire('add', opts);
        return promise;
    },
    /**
     * 添加引线弹框
     * @ignore
     * @method
     * @memberof G.common.PopupManager.prototype
     * @param {Object} opts 
     * @param {String} [opts.id]  唯一标识
     * @param {Array} opts.point  [x,y]，位置
     */
    addLinePopup(opts) {},

    /**
     * 更新
     * @method
     * @memberof G.common.PopupManager.prototype
     * @param {String} id 弹出框id
     * @param {String} opts 参数
     */
    update(id,opts) {
        return this.tooltipWare.updatePopup(id,opts);
    },
    /**
     * 更新位置
     * @method
     * @memberof G.common.PopupManager.prototype
     * @param {String} id 弹出框id
     */
    updatePosition(id) {
        return this.tooltipWare.updatePosition(id);
    },

    /**
     * 移除弹出框
     * @method
     * @memberof G.common.PopupManager.prototype
     * @param {String} id 
     */
    remove(id) {
        this.tooltipWare.removePopup(id);
        this._clearUpdatePosTimer(id);
        this.noneSpatialTipWare.removePopup(id);
        //
        this.fire('remove', {
            id,
        });
    },
    /**
     * 清除所有
     * @method
     * @memberof G.common.PopupManager.prototype
     */
    clear() {
        const idList = this.getIdList();
        if (this.tooltipWare) {
            this.tooltipWare.clearPopup();
        }
        if (this.noneSpatialTipWare) {
            this.noneSpatialTipWare.clearPopup();
        }
        this._clearUpdatePosTimer();
        this.fire('clear', {
            ids: idList,
        });
    },

    /**
     * 获取所有的弹出框Id
     * @method
     * @memberof G.common.PopupManager.prototype
     */
    getIdList() {
        return Object.keys(this.tooltipWare.tooltipSet);
    },

    //
    _triggerUpdateTimer(opts) {
        if (opts.autoPan !== false) {
            this._addUpdatePosTimer(opts.id, opts.autoPanTimeout);
        }
    },
    //
    _addUpdatePosTimer(id, autoPanTimeout) {
        // 定时触发更新详情框的动作
        const timer = setTimeout(() => {
            console.debug(`更新位置 ${id}`);
            this.updatePosition(id);
        }, autoPanTimeout || this.options.autoPanTimeout);
        this.timer = {
            id,
            timer,
        };
    },
    _clearUpdatePosTimer(id) {
        if (id === undefined) {
            if (this.timer) {
                window.clearTimeout(this.timer.timer);
            }
        } else {
            if (this.timer && this.timer.id === id) {
                window.clearTimeout(this.timer.timer);
            }
        }
        this.timer = null;
    },
});
module.exports = component;